/* CO36 — Mock Neck Claude PDP
   Companion to sections/mock-neck-claude-pdp.liquid. Contains no Liquid.

   Colors, sizes, pack cards and the first gallery are printed by Shopify, so
   the page is never blank if this file is blocked or slow. This only handles
   selection, the pre-order switch, add to cart and the two sheets. */
(function () {
  "use strict";

  function attr(el, name, dflt) {
    var v = el && el.getAttribute(name);
    return v === null || v === undefined || v === "" ? dflt : v;
  }

  function readJSON(root, sel, dflt) {
    var tag = root.querySelector(sel);
    if (!tag) return dflt;
    try { return JSON.parse(tag.textContent) || dflt; }
    catch (e) {
      if (window.console && console.error) console.error("[mock-neck-claude-pdp] " + sel, e);
      return dflt;
    }
  }

  /* "6pack:CODE" per line */
  function parseMap(text) {
    var out = {};
    String(text || "").split("\n").forEach(function (line) {
      var kv = line.split(":");
      if (kv.length >= 2) out[kv[0].trim()] = kv.slice(1).join(":").trim();
    });
    return out;
  }

  /* "badge|sub|price|was" */
  function parseCard(text) {
    var p = String(text || "").split("|");
    return { badge: (p[0] || "").trim(), sub: (p[1] || "").trim(),
             price: (p[2] || "").trim(), was: (p[3] || "").trim() };
  }

  function recommendSize(inches, pounds) {
    var h = Number(inches), w = Number(pounds);
    if (!h || !w) return "";
    if (h <= 66) return w <= 130 ? "XS" : w <= 145 ? "S" : w <= 189 ? "M" : w <= 215 ? "L" : w <= 240 ? "XL" : "XXL";
    if (h <= 69) return w <= 165 ? "S" : w <= 190 ? "M" : w <= 215 ? "L" : w <= 250 ? "XL" : "XXL";
    if (h <= 73) return w <= 175 ? "M" : w <= 220 ? "L" : w <= 250 ? "XL" : "XXL";
    if (h <= 76) return w <= 200 ? "L" : w <= 240 ? "XL" : "XXL";
    return w <= 235 ? "XL" : "XXL";
  }

  function fill(tpl, vals) {
    var out = String(tpl || "");
    for (var k in vals) {
      if (Object.prototype.hasOwnProperty.call(vals, k)) {
        out = out.split("[" + k + "]").join(vals[k]);
      }
    }
    return out;
  }

  function init(root) {
    var id = attr(root, "data-section-id", "");
    var bar = document.getElementById("pdp-bar-" + id);
    var finder = document.getElementById("pdp-finder-" + id);
    var sheet = document.getElementById("pdp-upsell-" + id);
    var buyBlock = root.querySelector("[data-buy]");

    var COLORS = readJSON(root, "[data-pdp-colors]", []);
    var SOLD = {};
    var soldList = readJSON(root, "[data-pdp-stock]", []);
    var hasStock = !!(soldList && soldList.length);
    (soldList || []).forEach(function (v) { SOLD[String(v)] = 1; });

    var SIZES = [];
    (function () {
      var b = root.querySelectorAll("[data-size]");
      for (var i = 0; i < b.length; i++) SIZES.push(b[i].getAttribute("data-size"));
    })();

    var CODES = parseMap(attr(root, "data-codes", ""));
    var SHIPDATE = attr(root, "data-shipdate", "");
    var SIX_ON = attr(root, "data-six", "") === "1";
    var PRE_ON = attr(root, "data-preorder", "") === "1";
    var UPSELL_ON = attr(root, "data-upsell", "") === "1";
    /* Where add to cart lands: the cart page, or straight to checkout. */
    var DEST = attr(root, "data-dest", "") === "checkout" ? "/checkout" : "/cart";

    var CARDS = {
      now: {
        "6pack": parseCard(attr(root, "data-card-six", "")),
        "3pack": parseCard(attr(root, "data-card-pack", "")),
        "single": parseCard(attr(root, "data-card-single", ""))
      },
      later: {
        "6pack": parseCard(attr(root, "data-precard-six", "")),
        "3pack": parseCard(attr(root, "data-precard-pack", "")),
        "single": parseCard(attr(root, "data-precard-single", ""))
      }
    };

    /* One field feeds both: a pipe makes it a fit note, three comma values
       make it a chart row. */
    var FIT = {};
    var CHART = [];
    attr(root, "data-sizing", "").split("\n").forEach(function (line) {
      if (line.indexOf("|") > -1) {
        var half = line.split("|");
        half[0].split(",").forEach(function (s) { FIT[s.trim().toUpperCase()] = half[1].trim(); });
        return;
      }
      var c = line.split(",");
      if (c.length >= 3) CHART.push({ size: c[0].trim(), chest: c[1].trim(), waist: c[2].trim() });
    });

    function colorByName(name) {
      for (var i = 0; i < COLORS.length; i++) if (COLORS[i].name === name) return COLORS[i];
      return COLORS[0] || { name: name, imgs: [], live: {}, pre: {} };
    }

    var hasPreIds = false;
    for (var pi = 0; pi < COLORS.length; pi++) {
      for (var pk in (COLORS[pi].pre || {})) {
        if (Object.prototype.hasOwnProperty.call(COLORS[pi].pre, pk) && COLORS[pi].pre[pk]) {
          hasPreIds = true; break;
        }
      }
      if (hasPreIds) break;
    }
    if (!hasPreIds && window.console && console.warn) {
      console.warn("[mock-neck-claude-pdp] no pre-order variant IDs are filled in, so pre-order falls back to the live IDs. Add them per Color block to charge the pre-order product.");
    }

    function variantId(colorName, size, later) {
      var c = colorByName(colorName);
      if (later && hasPreIds) {
        /* Blank here is deliberate: a colour we are not restocking. */
        return (c.pre || {})[size] || "";
      }
      return (c.live || {})[size] || "";
    }

    /* Only strike something out on positive proof it is gone: we must know the
       id AND have seen it in the sold-out list. Unknown means available —
       Shopify's cart still refuses a genuinely sold-out line. */
    function inStock(colorName, size, later) {
      /* A colour flagged "not coming back" is gone in pre-order mode no
         matter what the IDs say — it can still be bought from live stock. */
      if (later && colorByName(colorName).off) return false;
      if (later) {
        /* Pre-order sells past zero, so stock never applies. Without any
           pre-order ids nothing is crossed out at all. */
        if (!hasPreIds) return true;
        return !!variantId(colorName, size, true);
      }
      var vid = variantId(colorName, size, false);
      if (!vid || !hasStock) return true;
      return !SOLD[String(vid)];
    }

    var firstNames = COLORS.map(function (c) { return c.name; });
    function defaults(n) {
      var out = [];
      for (var i = 0; i < n; i++) out.push(firstNames[i % (firstNames.length || 1)] || "");
      return out;
    }

    var state = {
      pack: SIX_ON ? "6pack" : "3pack",
      size: "",
      color: attr(root, "data-default-color", firstNames[0] || ""),
      colors3: defaults(3),
      colors6: defaults(6),
      galleryColor: attr(root, "data-default-color", firstNames[0] || ""),
      shot: 0,
      later: false,
      chartOpen: false
    };

    function count() { return state.pack === "6pack" ? 6 : state.pack === "3pack" ? 3 : 1; }
    function listKey() { return count() === 6 ? "colors6" : "colors3"; }
    function chosen() { return count() > 1 ? state[listKey()] : [state.color]; }

    /* ---------- gallery ---------- */

    /* Build a colour's gallery the first time it is shown, from the JSON the
       section already ships. Keeps 30 images out of first paint. */
    function fillGallery(wrap, name) {
      if (!wrap.hasAttribute("data-lazygal")) return;
      wrap.removeAttribute("data-lazygal");
      var shots = (colorByName(name).imgs) || [];
      var main = wrap.querySelector("[data-main]");
      var strip = wrap.querySelector(".pdp-thumbs");
      if (shots.length) {
        main.innerHTML = '<img src="' + shots[0] + '" alt="' + name +
          '" decoding="async" fetchpriority="high">';
      } else {
        main.innerHTML = '<span class="pdp-ph-label">' + name + "</span>";
      }
      var html = "";
      for (var t = 1; t <= 4; t++) {
        html += '<button type="button" class="pdp-thumb" data-shot="' + t + '"' +
          (shots[t] ? "" : " data-empty") + ' aria-checked="false">' +
          (shots[t]
            ? '<img src="' + shots[t] + '" alt="" loading="lazy" decoding="async">'
            : '<div class="pdp-ph"><span class="pdp-ph-label">' + t + "</span></div>") +
          "</button>";
      }
      strip.innerHTML = html;
    }

    function paintGallery() {
      var wraps = root.querySelectorAll("[data-gal]");
      for (var i = 0; i < wraps.length; i++) {
        var on = wraps[i].getAttribute("data-gal") === state.galleryColor;
        wraps[i].hidden = !on;
        if (on) {
          fillGallery(wraps[i], state.galleryColor);
          var thumbs = wraps[i].querySelectorAll("[data-shot]");
          for (var t = 0; t < thumbs.length; t++) {
            thumbs[t].setAttribute("aria-checked",
              Number(thumbs[t].getAttribute("data-shot")) === state.shot ? "true" : "false");
          }
          var main = wraps[i].querySelector("[data-main] img");
          var shots = (colorByName(state.galleryColor).imgs) || [];
          if (main && shots[state.shot]) main.setAttribute("src", shots[state.shot]);
        }
      }
      var label = root.querySelector("[data-shown]");
      if (label) label.textContent = state.galleryColor;
    }

    /* ---------- selection ---------- */

    function paintSwatches(scope, selected) {
      var list = scope.querySelectorAll("[data-color]");
      for (var i = 0; i < list.length; i++) {
        var name = list[i].getAttribute("data-color");
        list[i].setAttribute("aria-checked", name === selected ? "true" : "false");
        /* Colors only read as gone once a size is chosen — before that there
           is nothing to be out of stock in. */
        var gone = !!state.size && !inStock(name, state.size, state.later);
        if (gone) list[i].setAttribute("data-gone", "1");
        else list[i].removeAttribute("data-gone");
      }
    }

    function paint() {
      var n = count();
      var later = state.later;
      var card = CARDS[later ? "later" : "now"][state.pack] || {};

      /* pack cards */
      var packs = root.querySelectorAll("[data-pack]");
      for (var i = 0; i < packs.length; i++) {
        var key = packs[i].getAttribute("data-pack");
        packs[i].setAttribute("aria-checked", key === state.pack ? "true" : "false");
        var c = CARDS[later ? "later" : "now"][key] || {};
        var set = function (sel, text) {
          var el = packs[i].querySelector(sel);
          if (el) el.textContent = text || "";
        };
        set("[data-card-badge]", c.badge);
        set("[data-card-sub]", c.sub);
        set("[data-card-price]", c.price);
        set("[data-card-was]", c.was);
        var badgeEl = packs[i].querySelector("[data-card-badge]");
        if (badgeEl) badgeEl.hidden = !c.badge;
        var wasEl = packs[i].querySelector("[data-card-was]");
        if (wasEl) wasEl.hidden = !c.was;
      }

      /* colour rows: show exactly as many as the pack needs */
      var rows = root.querySelectorAll("[data-row]");
      for (var r = 0; r < rows.length; r++) {
        var idx = Number(rows[r].getAttribute("data-row"));
        var show = n > 1 && idx < n;
        rows[r].hidden = !show;
        if (!show) continue;
        var name = state[listKey()][idx];
        var lab = rows[r].querySelector("[data-row-label]");
        if (lab) lab.textContent = "Shirt " + (idx + 1) + " of " + n;
        var chip = rows[r].querySelector("[data-chosen-label]");
        if (chip) chip.textContent = name;
        paintSwatches(rows[r], name);
      }

      var single = root.querySelector("[data-single]");
      if (single) {
        single.hidden = n > 1;
        var sl = single.querySelector("[data-chosen-label]");
        if (sl) sl.textContent = state.color;
        paintSwatches(single, state.color);
      }

      var groupLabel = root.querySelector("[data-color-step]");
      if (groupLabel) {
        groupLabel.textContent = n > 1
          ? fill(attr(root, "data-label-colors", "2. Choose [n] colors"), { n: n })
          : attr(root, "data-label-color", "2. Pick your color");
      }

      /* sizes */
      var sizeEls = root.querySelectorAll("[data-size]");
      var goneSizes = [];
      for (var s = 0; s < sizeEls.length; s++) {
        var sz = sizeEls[s].getAttribute("data-size");
        sizeEls[s].setAttribute("aria-checked", sz === state.size ? "true" : "false");
        var anywhere = false;
        for (var k = 0; k < COLORS.length && !anywhere; k++) {
          if (inStock(COLORS[k].name, sz, later)) anywhere = true;
        }
        if (anywhere) sizeEls[s].removeAttribute("data-gone");
        else { sizeEls[s].setAttribute("data-gone", "1"); goneSizes.push(sz); }
      }
      var note = root.querySelector("[data-soldnote]");
      if (note) {
        note.textContent = goneSizes.length ? "Sold out: " + goneSizes.join(", ") : "";
        note.hidden = !goneSizes.length;
      }

      /* pre-order pill */
      var pill = root.querySelector("[data-pill]");
      if (pill) {
        var show = PRE_ON && !later && !!state.size;
        pill.hidden = !show;
        if (show) {
          var pickedGone = !inStock(chosen()[0], state.size, false);
          var t = pill.querySelector("[data-pill-title]");
          var sub = pill.querySelector("[data-pill-sub]");
          if (t) {
            t.textContent = pickedGone
              ? fill(attr(root, "data-pill-gone", "[size] is sold out — pre-order"), { size: state.size })
              : attr(root, "data-pill-title", "Click here to pre-order");
          }
          if (sub) {
            sub.textContent = fill(attr(root, "data-pill-sub", ""), {
              date: SHIPDATE,
              save: n === 6 ? attr(root, "data-save-six", "")
                  : n === 3 ? attr(root, "data-save-pack", "")
                  : attr(root, "data-save-single", "")
            });
          }
        }
      }

      var banner = root.querySelector("[data-prebanner]");
      if (banner) banner.hidden = !later;
      var rnote = root.querySelector("[data-reservenote]");
      if (rnote) {
        rnote.hidden = !later;
        if (later) rnote.textContent = fill(attr(root, "data-reserve-note", ""), { date: SHIPDATE });
      }

      /* CTA */
      var cta = root.querySelector("[data-add]");
      if (cta) {
        var vals = { n: n, price: card.price || "", color: state.color, size: state.size, date: SHIPDATE };
        cta.textContent = !state.size
          ? attr(root, "data-cta-none", "Select your size")
          : later
            ? (n > 1 ? fill(attr(root, "data-cta-prepack", ""), vals) : fill(attr(root, "data-cta-presingle", ""), vals))
            : (n > 1 ? fill(attr(root, "data-cta-pack", ""), vals) : fill(attr(root, "data-cta-single", ""), vals));
      }

      if (bar) {
        var bt = bar.querySelector("[data-bar-title]");
        var bs = bar.querySelector("[data-bar-sub]");
        if (bt) bt.textContent = (n > 1 ? n + " Pack" : "Single") + " · " + (card.price || "");
        if (bs) bs.textContent = later ? "Ships " + SHIPDATE : (card.was ? "Was " + card.was : "");
      }

      paintGallery();
    }

    /* ---------- cart ---------- */

    function discountFor() {
      var n = count();
      var key = (state.later ? "pre" : "") + (n === 6 ? "6pack" : n === 3 ? "3pack" : "single");
      return CODES[key] || "";
    }

    function lineParts(extraItem) {
      var tally = {};
      var order = [];
      chosen().forEach(function (name) {
        var vid = variantId(name, state.size, state.later);
        if (!vid) return;
        if (!tally[vid]) { tally[vid] = 0; order.push(vid); }
        tally[vid]++;
      });
      if (extraItem) {
        var xid = String(extraItem.id);
        if (!tally[xid]) { tally[xid] = 0; order.push(xid); }
        tally[xid] += extraItem.quantity || 1;
      }
      return order.map(function (vid) { return vid + ":" + tally[vid]; });
    }

    /* One navigation, no fetch: /cart/<id>:<qty>,... carries the whole order,
       the discount and the ship note, and return_to lands on checkout. */
    function permalink(extraItem, dest) {
      var parts = lineParts(extraItem);
      if (!parts.length) return "/cart";

      var qs = [];
      var code = discountFor();
      if (code) qs.push("discount=" + encodeURIComponent(code));
      if (state.later && SHIPDATE) {
        qs.push("attributes[Ships]=" + encodeURIComponent(SHIPDATE));
      }
      qs.push("attributes[Order type]=" + encodeURIComponent(
        (state.later ? "Reserve" : "Buy now") + " – " + (count() > 1 ? count() + " Pack" : "Single")
      ));
      qs.push("return_to=" + encodeURIComponent(dest || DEST));

      return "/cart/" + parts.join(",") + "?" + qs.join("&");
    }

    function goCart(extraItem, dest) {
      var cta = root.querySelector("[data-add]");
      if (cta) {
        cta.textContent = (dest || DEST) === "/checkout" ? "Taking you to checkout…" : "Adding to cart…";
        cta.setAttribute("data-busy", "1");
      }
      window.location.href = permalink(extraItem, dest);
    }

    function addToCart() {
      if (!state.size) { openFinder(); return; }
      if (UPSELL_ON && sheet) { openSheet(); return; }
      goCart(null);
    }

    /* ---------- cross-sell sheet ---------- */

    function openSheet() {
      if (!sheet) return;
      var name = chosen()[0];
      var q = sheet.querySelector("[data-upsell-q]");
      if (q) {
        q.textContent = fill(attr(sheet, "data-question", ""), { color: name, size: state.size });
      }
      var price = state.later
        ? attr(sheet, "data-pre-price", "")
        : attr(sheet, "data-price", "");
      var pEl = sheet.querySelector("[data-upsell-price]");
      if (pEl) pEl.textContent = price;
      var wEl = sheet.querySelector("[data-upsell-was]");
      if (wEl) {
        wEl.textContent = state.later ? attr(sheet, "data-price", "") : "";
        wEl.hidden = !state.later;
      }
      var nEl = sheet.querySelector("[data-upsell-note]");
      if (nEl) {
        nEl.textContent = fill(attr(sheet, state.later ? "data-pre-note" : "data-note", ""), { date: SHIPDATE });
      }
      var yes = sheet.querySelector("[data-upsell-yes]");
      if (yes) yes.textContent = fill(attr(sheet, "data-cta", ""), { price: price });
      var metaEl = sheet.querySelector("[data-added-meta]");
      if (metaEl) metaEl.textContent = chosen().join(", ") + " · " + state.size;
      var titleEl = sheet.querySelector("[data-added-title]");
      if (titleEl) {
        titleEl.textContent = attr(root, "data-product-title", "") +
          (count() > 1 ? ", " + count() + " Pack" : "");
      }
      sheet.hidden = false;
    }

    function addUpsell() {
      var map = readJSON(sheet, "[data-pdp-upsell-ids]", {});
      var table = state.later ? (map.pre || {}) : (map.live || {});
      var vid = ((table[chosen()[0]] || {})[state.size]) || "";
      goCart(vid ? { id: Number(vid), quantity: 1 } : null);
    }

    /* ---------- size finder ---------- */

    function openFinder() { if (finder) finder.hidden = false; }
    function closeFinder() { if (finder) finder.hidden = true; }

    if (finder) {
      var heightSel = finder.querySelector("[data-height]");
      if (heightSel && heightSel.options.length <= 1) {
        for (var ft = 5; ft <= 6; ft++) {
          var last = ft === 6 ? 6 : 11;
          for (var inch = 0; inch <= last; inch++) {
            var opt = document.createElement("option");
            opt.value = String(ft * 12 + inch);
            opt.textContent = ft + "'" + inch + '"';
            heightSel.appendChild(opt);
          }
        }
      }

      var chartRows = function (rec) {
        var html = '<div class="pdp-ch pdp-ch-h">Size</div>' +
          '<div class="pdp-ch pdp-ch-h pdp-ch-r">Chest</div>' +
          '<div class="pdp-ch pdp-ch-h pdp-ch-r">Waist</div>';
        CHART.forEach(function (m) {
          var on = m.size.toUpperCase() === String(rec || "").toUpperCase();
          var cls = "pdp-ch" + (on ? " pdp-ch-on" : "");
          html += '<div class="' + cls + '">' + m.size + "</div>" +
            '<div class="' + cls + ' pdp-ch-r">' + m.chest + "</div>" +
            '<div class="' + cls + ' pdp-ch-r">' + m.waist + "</div>";
        });
        return html;
      };

      var refresh = function () {
        var rec = recommendSize(heightSel.value, finder.querySelector("[data-weight]").value);
        finder.querySelector("[data-result]").hidden = !rec;
        finder.querySelector("[data-apply]").hidden = !rec;
        finder.querySelector("[data-rec-size]").textContent = rec;
        finder.querySelector("[data-fit-note]").textContent = FIT[rec] || "";
        finder.querySelector("[data-chart]").innerHTML = chartRows(rec);
      };

      heightSel.addEventListener("change", refresh);
      finder.querySelector("[data-weight]").addEventListener("input", refresh);
      finder.querySelector("[data-close]").addEventListener("click", closeFinder);
      finder.addEventListener("click", function (e) { if (e.target === finder) closeFinder(); });
      finder.querySelector("[data-apply]").addEventListener("click", function () {
        var rec = finder.querySelector("[data-rec-size]").textContent;
        if (!rec) return;
        state.size = rec;
        closeFinder();
        paint();
      });
      finder.querySelector("[data-chart]").innerHTML = chartRows("");
    }

    /* ---------- events ---------- */

    root.addEventListener("click", function (e) {
      var t = e.target.closest(
        "[data-pack],[data-color],[data-size],[data-shot],[data-add],[data-open-finder],[data-pill],[data-undo],[data-acc],[data-to-buy]"
      );
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute("data-pack")) {
        state.pack = t.getAttribute("data-pack");
        return paint();
      }

      if (t.hasAttribute("data-color")) {
        if (t.hasAttribute("data-gone")) return;
        var name = t.getAttribute("data-color");
        var row = t.closest("[data-row]");
        if (row) {
          var idx = Number(row.getAttribute("data-row"));
          var arr = state[listKey()].slice();
          arr[idx] = name;
          state[listKey()] = arr;
        } else {
          state.color = name;
        }
        state.galleryColor = name;
        state.shot = 0;
        return paint();
      }

      if (t.hasAttribute("data-size")) {
        state.size = t.getAttribute("data-size");
        return paint();
      }

      if (t.hasAttribute("data-shot")) {
        if (t.hasAttribute("data-empty")) return;
        state.shot = Number(t.getAttribute("data-shot"));
        return paintGallery();
      }

      if (t.hasAttribute("data-add")) {
        if (t.hasAttribute("data-busy")) return;
        return addToCart();
      }

      if (t.hasAttribute("data-open-finder")) return openFinder();

      if (t.hasAttribute("data-pill")) {
        state.later = true;
        return paint();
      }

      if (t.hasAttribute("data-undo")) {
        state.later = false;
        state.size = "";
        return paint();
      }

      if (t.hasAttribute("data-to-buy")) {
        if (!buyBlock) return;
        var top = buyBlock.getBoundingClientRect().top +
          (window.pageYOffset || document.documentElement.scrollTop) - 12;
        try { window.scrollTo({ top: top, behavior: "smooth" }); }
        catch (err) { window.scrollTo(0, top); }
        return;
      }

      if (t.hasAttribute("data-acc")) {
        var panel = t.nextElementSibling;
        var sign = t.querySelector("[data-acc-sign]");
        if (panel) {
          var open = panel.hidden;
          panel.hidden = !open;
          if (sign) sign.textContent = open ? "–" : "+";
        }
        return;
      }
    });

    if (bar) {
      bar.addEventListener("click", function (e) {
        if (!e.target.closest("[data-to-buy]")) return;
        if (!buyBlock) return;
        var top = buyBlock.getBoundingClientRect().top +
          (window.pageYOffset || document.documentElement.scrollTop) - 12;
        try { window.scrollTo({ top: top, behavior: "smooth" }); }
        catch (err) { window.scrollTo(0, top); }
      });
    }

    if (sheet) {
      sheet.addEventListener("click", function (e) {
        if (e.target.closest("[data-upsell-yes]")) return addUpsell();
        if (e.target === sheet || e.target.closest("[data-upsell-no]")) {
          e.preventDefault();
          goCart(null, "/cart");
        }
      });
    }

    /* videos: swap the poster for the player on click */
    root.addEventListener("click", function (e) {
      var play = e.target.closest("[data-play]");
      if (!play) return;
      var frame = play.closest("[data-video]");
      var url = frame && frame.getAttribute("data-video");
      if (!url) return;
      var src = url;
      var yt = url.match(/(?:youtu\.be\/|[?&]v=|embed\/|shorts\/)([\w-]{6,})/);
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (yt) src = "https://www.youtube.com/embed/" + yt[1] + "?autoplay=1&rel=0&modestbranding=1&playsinline=1";
      else if (vm) src = "https://player.vimeo.com/video/" + vm[1] + "?autoplay=1";
      frame.innerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen loading="lazy"></iframe>';
    });

    root.classList.add("pdp-js");
    paint();
  }

  function boot() {
    var all = document.querySelectorAll("[data-pdp]");
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute("data-ready")) continue;
      all[i].setAttribute("data-ready", "1");
      try { init(all[i]); }
      catch (err) {
        if (window.console && console.error) {
          console.error("[mock-neck-claude-pdp] setup failed:", (err && err.message) || err, (err && err.stack) || "");
        }
      }
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
